import { useDispatch } from 'react-redux';
import { CloseIcon } from '../../../../assets/icons/Svg'
import { clearSelectedId, clearTypeOfAdditionalModal, clearTypeOfShowModalType, setTypeOfShowModalType } from '../../../../features/modal/modalSlice';
import { clearPackagesFromChapel } from '../../../../features/package/packageSlice';
import { clearDefaultPackage, resetClientForm, resetClientState } from '../../../../features/client/clientSlice';

interface ClientModalHeaderProps {
    typeOfAction: string;
}

export default function ClientModalHeader({ typeOfAction }: ClientModalHeaderProps) {

    const dispatch = useDispatch()

    const handleCloseNewClient = (typeOfAction: string) => {
        if(typeOfAction === 'update') {
            dispatch(clearTypeOfAdditionalModal())
            dispatch(setTypeOfShowModalType('viewClient'))
            dispatch(clearPackagesFromChapel())
            dispatch(resetClientForm())
            // dispatch(resetClientState())
            return;
        }
        dispatch(clearTypeOfShowModalType())
        dispatch(clearPackagesFromChapel())
        dispatch(clearSelectedId())
        dispatch(resetClientForm())
        dispatch(clearDefaultPackage())
        dispatch(resetClientState())
    }
    
    return (
        <div className="flex justify-between items-center py-1">
            <div className="items-start">
                <p className="text-sm items-start font-semibold leading-tight text-slate-900">
                    {typeOfAction === 'update' && 'Update Client'}
                    {typeOfAction === 'newClient' && 'New Client'}
                </p>
            </div>
            <div className="flex justify-end items-center">
                <button
                    type="button"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                    onClick={() => handleCloseNewClient(typeOfAction)}
                >
                    <CloseIcon/>
                </button>
            </div>
        </div>
    )
}
